import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchGraphUniqueBookings } from "./uniqueBookingsAPI";

const initialState = {
    status: "idle",
    error: null,
    data: {},
    bookingsVisitors: [],
    bookingsPercentVisitors: [],
    weeks: [],
};

export const graphUniqueBookings = createAsyncThunk(
  "uniqueBookings/bookings",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-uniqueBookings`;
      const response = await fetchGraphUniqueBookings(dbpath, user, 'graph-uniqueBookings');
        return response.data;
    } catch (error) {
        return rejectWithValue(error);
    }
  }
);

const uniqueBookingsSlice = createSlice({
  name: "uniqueBookings",
  initialState,
  reducers: {
    resetuniqueBooking: (state, action) => {
      return { ...initialState };
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(graphUniqueBookings.pending, (state) => {
        state.status = "loading";
      })
      .addCase(graphUniqueBookings.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        const result = action.payload;
        try {
          state.data = result;
          state.bookingsVisitors = result[0][0]["data"];
          state.bookingsPercentVisitors = result[0][1]["data"];
          state.weeks = result[1];
        } catch (error) {
          // console.warn("uniqueBookings data not found!", error)
        }

      })
      .addCase(graphUniqueBookings.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      });
  },
});

export const { resetuniqueBooking } = uniqueBookingsSlice.actions;

    
export const SelectBookingsVisitors = (state) => state.uniqueBookings.bookingsVisitors;
export const SelectBookingsPercentVisitors = (state) => state.uniqueBookings.bookingsPercentVisitors;
export const SelectWeeks = (state) => state.uniqueBookings.weeks;
export const SelectUniqueBookingsStatus = (state) => state.uniqueBookings.status;

export default uniqueBookingsSlice.reducer;
